<template>
    <div style="background: #4D4D4D">

        <header class="w100" :style="headerAreaStyle">
            <div class="d-flex justify-content-center">
                <div class="pr-2 align-self-center" style="position:absolute;left:0;">
                    <div class="text-truncate">
                        <a class="header-back" v-bind:href="getMangahotDetailUrl(workCode, restoreToken, timeRes, pid)">
            <img src="/koreyomo/static/assets/images/arrow_left.png" width="30" height="30" ><span class="header-back">作品詳細へ戻る</span>
                        </a>
                    </div>
                </div>
                <div class="align-self-center d-none d-sm-block">
                    <span class="header-title pr-2">この話の続きはアプリで！ アプリ<strong>『マンガほっと』</strong>は最新話まで<strong>基本無料！</strong></span>
                </div>

                <div class="align-self-center d-none d-sm-block" style="position:absolute;right:0;">
        <a v-bind:href="linkAppStore"><img id="appStore" src="/koreyomo/static/assets/images/apple.png" width="120"></a>
        <a v-bind:href="linkGooglePlay"><img id="googlePlay" src="/koreyomo/static/assets/images/google.png" width="120"></a>
                </div>

            </div>
        </header>

        <div class="contents">
            <div id="comic-viewer" v-bind:style="contentsAreaStyle">
                <!-- Right page -->
      <div id="comic-page-right" class="page-contents" v-bind:style="rightPageStyle" v-on:click="clickRightPage">
                    <CoverPage v-show="shouldShowCover(rightPageType)"
                               v-bind:catch-phrase="catchPhrase"
                               v-bind:work-name="workName"
                               v-bind:author-name="authorName"
                               v-bind:story-title="storyTitle"/>
                    <AdvertisementPage v-show="shouldShowAdvertisement(rightPageType)"/>
                    <ComicPage v-show="shouldShowComic(rightPageType)"
                               v-bind:image-list="rightImages"
                               v-bind:image-index="rightImageIndex"/>

                    <img id="comic-arrow-right"
                         class='comic-page-arrow'
                         src="/koreyomo/static/assets/images/arrow_right.png"
                         v-bind:style="rightArrowStyle"
                         v-show="showRightArrow"/>
                </div>

                <!-- Left page -->
                <div id="comic-page-left" class="page-contents" v-bind:style="leftPageStyle" v-on:click="clickLeftPage">
                    <ViewerLastPage v-if="ViewerLastPageLoaded"
                                    v-show="shouldShowLastPage(leftPageType)"
                                    v-bind:work-info="workInfo"
                                    v-bind:next-story-item="nextStoryItem"
                                    v-bind:recommend-items="recommendItems"
                                    v-bind:work-background-color="workBackgroundColor"
                                    v-bind:restore-token="restoreToken"
                                    v-bind:time-res="timeRes"
                                    v-bind:pid="pid"
                    />
                    <BlankPage v-show="shouldShowBlank(leftPageType)"/>
                    <ComicPage v-show="shouldShowComic(leftPageType)"
                               v-bind:image-list="leftImages"
                               v-bind:image-index="leftImageIndex"/>

                    <img id="comic-arrow-left"
                         class='comic-page-arrow'
                         src="/koreyomo/static/assets/images/arrow_left.png"
                         v-bind:style="leftArrowStyle"
                         v-show="showLeftArrow"/>

                </div>
            </div>
        </div>

        <!-- Recommend dialog -->
        <div class="modal fade" id="modalRecommend" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" style="width:100%;" role="document">
                <div class="modal-content" v-bind:style="backgroundStyle">
                    <div class="modal-body">
                        <div v-bind:style="backgroundStyle">
                            <RecommendPanel v-bind:ranking-works="recommendRankingWorks"
                                            v-bind:persona-text="recommendPersonaText"
                                            v-bind:work-info="topWorkItem"
                                            v-bind:persona-id="pid"
                                            v-bind:time-res="timeRes"
                                            v-bind:restore-token="restoreToken"
                                            v-bind:read-pages="currentPageIndex"
                                            v-bind:total-pages="numberOfPages"/>

                            <div class="d-flex justify-content-center">

                <a href="#" class="btn btn-read-recommend-dialog m-2" v-bind:style="buttonStyle" data-dismiss="modal">閉じる（試し読み再開）</a>
                                <router-link class="btn btn-read-recommend-dialog m-2"
                                             v-bind:style="buttonStyle"
                                             data-dismiss="modal"
                                             :key="$route.fullPath"
                            :to="{ path: '/recommend', query: { m: 2, rt: restoreToken, timeres: timeRes, pid: pid }}">おすすめ結果へもどる</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer>
            <div class="d-flex flex-row py-3"
                 v-bind:style="pageSliderStyle">
                <img class="w-auto mr-2"
                     src="/koreyomo/static/assets/images/mai_part-20.png"
                     width="120" height="40"
                     v-show="recommendRankingWorks.length > 0 && mangaJp"
                     data-toggle="modal" data-target="#modalRecommend"
                     style="cursor:pointer;"/>
                <input id="slider-page"
                       type="range" min="0" v-bind:max="lastPageIndex" v-model.number="currentPageIndex"
                       key="input-page-index"
                       step="2"
                       class="slider-rtl slider-color slider-viewer align-self-center"
                >
            </div>
        </footer>
    </div>
</template>

<script>
    import _ from 'lodash'
    import * as consts from '../constants';
    import App from "../App";
    import * as Api from '../api/apies6.js';
    import CoverPage from "../components/CoverPage";
    import BlankPage from "../components/BlankPage";
    import AdvertisementPage from "../components/AdvertisementPage";
    import ViewerLastPage from "../components/ViewerLastPage";
    import RecommendPanel from "../components/RecommendPanel";
    import ComicPage from "../components/ComicPage";
    import dynamicStyleMixin from "../components/DynamicStyleMixin";

    const PAGE_TYPE_COMIC = 1
    const PAGE_TYPE_COVER = 2
    const PAGE_TYPE_BLANK = 3
    const PAGE_TYPE_ADVERTISEMENT = 4
    const PAGE_TYPE_VIEWER_LAST_PAGE = 5

    const MIN_CONTENT_WIDTH = 720
    const MIN_CONTENT_HEIGHT = 520

    export default {
        name: "ViewerPc",
        components: {ComicPage, RecommendPanel, ViewerLastPage, AdvertisementPage, BlankPage, CoverPage, App},
        mixins: [dynamicStyleMixin],
        data() {
            return {
                /** @type {KoreyomoStoryResult} */
                storyResult: new Api.KoreyomoStoryResult(),

                workBackgroundColor: "#000000",
                catchPhrase: "",
                workName: "",
                authorName: "",
                storyTitle: "",
                lastPageWorkImageUrl: "",

                restoreToken: null,
                timeRes: null,
                pid: null,

                /** @type {KoreyomoWorkInfo} */
                workInfo: null,
                nextStoryItem: null,
                recommendItems: [],

                recommendRankingWorks: [],
                recommendPersonaText: "",

                /** @type {Array.<string>} Array of content URLs */
                contentUrls: [],

                // The page number on the left side currently displayed. zero-based index.
                currentPageIndex: 0,

                // Size excluding header and footer.
                contentsWidth: 0,
                contentsHeight: 0,

                // The comic image is fixed at 1080 x 1536 pixels.
                // If it is changed, it must be obtained dynamically from image.
                originalImageWidth: 1080,
                originalImageHeight: 1536,

                imageWidth: 0,
                imageHeight: 0,
                imageOffsetXOfLeftPage: 0,
                imageOffsetXOfRightPage: 0,
                imageOffsetY: 0,
                showLeftArrow: false,
                showRightArrow: false,
                topWorkItem: null,
                shareTextTwitter: 'Koreyomo',
                shareTextFB: 'Koreyomo',
                ViewerLastPageLoaded: false,
                recommendWorksFromWorksData: [],
                mangaJp: true
            }
        },
        computed: {
            workCode: function () {
                return this.workInfo ? this.workInfo.workCode : ""
            },

            headerAreaStyle: function () {
                let headerWidth = this.contentsWidth - 300
                return {
                    'width': headerWidth + 'px',
                    'margin': '0 auto',
                    'overflow': 'hidden',
                    'position': 'relative'
                }
            },
            // Content area is the area excluding header and footer.
            contentsAreaStyle: function () {
                return {
                    'width': this.contentsWidth + 'px',
                    'height': this.contentsHeight + 'px',
                }
            },
            // Relative position from content area
            leftPageStyle: function () {
                return {
                    'position': 'absolute',
                    'left': this.imageOffsetXOfLeftPage + 'px',
                    'top': this.imageOffsetY + 'px',
                    'width': this.imageWidth + 'px',
                    'height': this.imageHeight + 'px'
                }
            },
            rightPageStyle: function () {
                return {
                    'position': 'absolute',
                    'left': this.imageOffsetXOfRightPage + 'px',
                    'top': this.imageOffsetY + 'px',
                    'width': this.imageWidth + 'px',
                    'height': this.imageHeight + 'px'
                }
            },

            rightArrowStyle: function () {
                return {
                    'position': 'absolute',
                    'right': '6px',
                    'top': '50%'
                }
            },
            leftArrowStyle: function () {
                return {
                    'position': 'absolute',
                    'left': '6px',
                    'top': '50%'
                }
            },
            pageSliderStyle: function () {
                // Fit to the width of the comic.
                return {
                    'margin-left': this.imageOffsetXOfLeftPage + 'px',
                    'width': (this.imageWidth * 2) + 'px',
                }
            },
            numberOfPages: function () {
                return this.contentUrls.length
            },
            lastPageIndex: function () {
                let page = (this.numberOfPages - 1);
                this.$cookies.set('feedbacktotalPages', page, '100MIN');
                // Add blank page
                if (page % 2 === 1) {
                    page += 1
                }
                // Last page and advertisement page.
                page += 2

                return page
            },
            leftImageIndex: function () {
                return this.currentPageIndex / 2
            },
            rightImageIndex: function () {
                return this.currentPageIndex / 2 - 1
            },
            leftImages: function () {
                let result = []
                for (let i = 0; i < this.contentUrls.length; i += 2) {
                    let url = this.urlAtIndex(i)
                    if (url !== null) {
                        result.push(url);
                    }
                }
                return result
            },
            rightImages: function () {
                // At first, it is a cover page so skip.
                let result = []
                for (let i = 1; i < this.contentUrls.length; i += 2) {
                    let url = this.urlAtIndex(i)
                    if (url !== null) {
                        result.push(url);
                    }
                }
                return result
            },
            leftPageType: function () {
                this.$cookies.set('feedbackcurrentPageIndex', this.currentPageIndex, '100MIN');
                if (this.currentPageIndex >= this.numberOfPages) {
                    if (this.currentPageIndex === this.lastPageIndex) {
                        return PAGE_TYPE_VIEWER_LAST_PAGE
                    } else {
                        return PAGE_TYPE_BLANK
                    }
                }
                return PAGE_TYPE_COMIC
            },
            rightPageType: function () {
                this.$cookies.set('feedbackcurrentPageIndex', this.currentPageIndex, '100MIN');
                if (this.currentPageIndex === 0) {
                    return PAGE_TYPE_COVER
                }

                // When the number of pages is an even number, one page remains.
                // In this case, the left page is blank and the right page is the last of the comic.
                if (this.currentPageIndex >= this.numberOfPages + 1) {
                    if (this.currentPageIndex === this.lastPageIndex) {
                        return PAGE_TYPE_ADVERTISEMENT
                    } else {
                        return PAGE_TYPE_BLANK
                    }
                }
                return PAGE_TYPE_COMIC
            },
            // Override DynamicStyleMixin
            styleObject: function () {
                return this.topWorkItem
            },
        },
        methods: {
            onResize: _.throttle(function () {
                this.layoutContent()
            }, 100),
            onKeyDown(e) {
                // Prevent multiple moves.
                if (this.hasFocusPageSlider()) {
                    return
                }

                let keyName = e.key
                if (keyName === "ArrowLeft" || keyName === "Left") {
                    if (this.currentPageIndex === this.lastPageIndex) {
                        this.gtagFunction(consts.HIT_TYPE.PAGE_VIEW, consts.EVENT_CATEGORY.VIEWER, document.title + consts.EVENT_LABEL.LAST_PAGE_POST, 'no');
                    }
                    this.clickLeftPage()
                } else if (keyName === "ArrowRight" || keyName === "Right") {
                    this.clickRightPage()
                } else if (keyName === " " || keyName === "Spacebar") {
                    // Space Key
                    this.clickLeftPage()
                }
            },
            urlAtIndex(index) {
                let urls = this.contentUrls
                if (index < 0 || index >= urls.length) {
                    return null;
                }
                return urls[index]
            },
            layoutContent() {
                let headerHeight = $('header').innerHeight()
                let footerHeight = $('footer').innerHeight()

                // set content size.
                let windowWidth = $(window).width()
                let windowHeight = $(window).height()

                let contentsWidth = Math.max(windowWidth, MIN_CONTENT_WIDTH)
                // ignore header and footer area.
                let contentsHeight = Math.max(windowHeight - (headerHeight + footerHeight), MIN_CONTENT_HEIGHT)

                let halfWidth = Math.floor(contentsWidth / 2)

                // Calculate the size that fits in the content area.
                // Calculate per page. Therefore the width is half of the content area.
                let r1 = halfWidth / this.originalImageWidth
                let r2 = contentsHeight / this.originalImageHeight
                let ratio = r1 < r2 ? r1 : r2

                this.imageWidth = Math.floor(this.originalImageWidth * ratio)
                this.imageHeight = Math.floor(this.originalImageHeight * ratio)

                this.contentsWidth = contentsWidth
                this.contentsHeight = contentsHeight

                this.imageOffsetXOfLeftPage = halfWidth - this.imageWidth
                this.imageOffsetXOfRightPage = halfWidth
                this.imageOffsetY = (contentsHeight - this.imageHeight) / 2 // Vertical center alignment
            },
            clickLeftPage() {
                // Next page
                this.currentPageIndex = Math.min(this.currentPageIndex + 2, this.lastPageIndex)
                if (this.leftPageType == PAGE_TYPE_VIEWER_LAST_PAGE) {
                    this.gtagFunction(consts.HIT_TYPE.PAGE_VIEW, consts.EVENT_CATEGORY.VIEWER, document.title + consts.EVENT_LABEL.LAST_PAGE_POST, 'no');
                }
            },
            clickRightPage() {
                this.currentPageIndex = Math.max(this.currentPageIndex - 2, 0)
            },
            clickOtherWorks() {
                $('#modalRecommend').modal('show')
            },
            hasFocusPageSlider() {
                let hasFocus = $('#slider-page').is(':focus');
                return hasFocus
            },
            hideNavigationButton() {
                $('#comic-arrow-left').fadeOut()
                $('#comic-arrow-right').fadeOut()
            },
            async doGet() {
                let workCode = this.$route.params.workCode
                let storyId = this.$route.params.storyId

                let api = new Api.KoreyomoApi(this.getApiConfig())
                let result = await api.worksStoryDetailWorkCodeStoryIdGetAsync(workCode, storyId)

                this.contentUrls = result.content.contentUrls

                this.workBackgroundColor = result.workInfo.backgroundColor
                this.catchPhrase = result.workInfo.catchPhrase
                this.workName = result.workInfo.workName
                this.authorName = result.workInfo.authorName
                this.storyTitle = result.storyItem.storyTitle
                this.lastPageWorkImageUrl = result.workInfo.bannerLargeImageUrl

                this.workInfo = result.workInfo
                this.nextStoryItem = result.nextStoryItem
                this.recommendItems = result.recommendWorks

                document.title = "無料試し読み、" + result.workInfo.workName + " " + result.storyItem.storyTitle + " | マンガほっと";
                document.getElementsByTagName('meta')["description"].content = result.workInfo.catchPhrase + " | " + result.workInfo.workName;

                this.gtagFunction(consts.HIT_TYPE.PAGE_VIEW, consts.EVENT_CATEGORY.VIEWER, document.title + consts.EVENT_LABEL.VIEWER_POST, 'no');

                this.restoreToken = this.$route.query.rt;
                if (this.restoreToken != '' || this.restoreToken.length > 0) {
                    let resultRecommends = await api.worksRecommendWorksFromTokenGetAsync(this.restoreToken)
                    this.recommendWorksFromWorksData = resultRecommends
                    this.recommendPersonaText = resultRecommends.maiResult.personaText
                    this.recommendRankingWorks = resultRecommends.rankingWorks
                    this.topWorkItem = resultRecommends.topWorkItem;
                    this.shareTextTwitter = '「' + this.workInfo.workName + '」 をおすすめします！試し読み⇒'
                    this.shareTextFB = '「' + this.recommendWorksFromWorksData.rankingWorks[0].workName + '」| マンガほっと'
                } else {
                    this.recommendWorksFromWorksData = []
                    this.recommendPersonaText = ""
                    this.recommendRankingWorks = []
                    this.topWorkItem = null;
                    this.shareTextTwitter = '「' + this.workInfo.workName + '」 をおすすめします！試し読み⇒'
                    this.shareTextFB = ''
                }

                this.ViewerLastPageLoaded = true;
            },
            shouldShowComic(type) {
                return type === PAGE_TYPE_COMIC
            },
            shouldShowCover(type) {
                return type === PAGE_TYPE_COVER
            },
            shouldShowBlank(type) {
                return type === PAGE_TYPE_BLANK
            },
            shouldShowAdvertisement(type) {
                return type === PAGE_TYPE_ADVERTISEMENT
            },
            shouldShowLastPage(type) {
                return type === PAGE_TYPE_VIEWER_LAST_PAGE
            },
        },
        async created() {
            let self = this;
            await self.doGet()

            $('meta[property=og\\:title]').attr('content', this.shareTextFB);
            $('meta[property=og\\:description]').attr('content', this.catchPhrase);
            $('meta[property=og\\:site_name]').attr('content', 'マンガほっと');

            window.addEventListener('resize', self.onResize, false);
            window.addEventListener('keydown', self.onKeyDown, false)
            self.showLeftArrow = true;
            self.showRightArrow = true;
            // Apply custom background color.
            $('#modalRecommend').on('shown.bs.modal', function (e) {
                self.gtagFunction(consts.HIT_TYPE.PAGE_VIEW, consts.EVENT_CATEGORY.VIEWER, consts.EVENT_LABEL.RECOMMEND_MODAL, 'no');
                $('body').addClass('modal-recommend-open');
            }).on('hidden.bs.modal', function (e) {
                $('body').removeClass('modal-recommend-open');
            });

            setTimeout(this.hideNavigationButton, 4000);

            // First update the layout.
            self.$nextTick(() => {
                self.layoutContent()
            })

            self.$cookies.set('feedbackworkCode', self.$route.params.workCode, '100MIN');
            self.$cookies.set('feedbackstoryId', self.$route.params.storyId, '100MIN');
            self.$cookies.set('feedbackpid', self.$route.query.pid, '100MIN');
            self.$cookies.set('feedbacktimeRes', self.$route.query.timeres, '100MIN');
            let rt = self.$route.query.rt
            if (rt == '' || rt.length < 1) {
                self.mangaJp = false
            }
        },
        beforeDestroy: function () {
            window.removeEventListener('keydown', this.onKeyDown, false)
            window.removeEventListener('resize', this.onResize, false);
        },
        watch: {
            "$route.params.storyId"(val) {
                // TODO: It is necessary to consider whether there is a problem with the implementation of the reload.
                location.reload()
            }
        }

    }
</script>

<style scoped>
    footer {
        background-color: #4D4D4D;
    }

    .contents {
        margin: 0;
        background-color: #4D4D4D;
    }

    #comic-viewer {
        position: relative;
    }

    #comic-page-left {
    }

    #comic-page-right {
    }

    .comic-page {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .comic-page-arrow {
        position: absolute;
        width: 50px;
        height: 50px;
        margin-top: -25px;

        /* Background circle */
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        padding: 8px;
    }

    .slidecontainer {
        width: 100%;
    }

    .slider-rtl {
        direction: rtl
    }

    .slider-viewer {
        border-radius: 10px;
    }

    .slider-viewer::-webkit-slider-thumb {
        background: #B2B2B2;
    }

    .slider-viewer::-moz-range-thumb {
        background: #B2B2B2;
    }

    input[type=range]::-ms-thumb {
        background: #B2B2B2;
    }

    .footer {
        background-color: #4D4D4D
    }

    @media (max-width: 1070px) {
        .header-title {
            font-size: 12px;
        }

        /* #appStore {
          width: 110px;
        }

        #googlePlay {
          width: 110px;
        } */
    }

    @media (max-width: 992px) {
        .header-title {
            font-size: 11px;
        }

        #appStore {
            width: 100px;
        }

        #googlePlay {
            width: 100px;
        }
    }

    @media (max-width: 890px) {
        .header-title {
            font-size: 10px;
        }

        #appStore {
            width: 95px;
        }

        #googlePlay {
            width: 95px;
        }
    }

    @media (max-width: 768px) {
        .header-title {
            font-size: 8px;
        }

        #appStore {
            width: 80px;
        }

        #googlePlay {
            width: 80px;
        }
    }

    @media (max-width: 690px) {
        .header-title {
            font-size: 8px;
        }

        #appStore {
            width: 65px;
        }

        #googlePlay {
            width: 65px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/ViewerPc.vue